import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import AppHeader from "@/components/AppHeader";
import AppSidebar from "@/components/AppSidebar";
import { api, formatApiError } from "@/lib/api";
import { ProgressNoteReviewCard } from "@/components/progress-notes/ProgressNoteReviewCard";
import { ProgressNotePayLines } from "@/components/progress-notes/ProgressNotePayLines";

const TABS = [["Submitted", "Needs approval"], ["Approved", "Approved"], ["Returned", "Returned"], ["pay_lines", "Pay lines"]];

export default function ProgressNotesPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab") || "Submitted";
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");

  const load = useCallback(async () => {
    try {
      const response = await api.get("/progress-notes", { params: { status_filter: tab === "pay_lines" ? "Approved" : tab } });
      setData(response.data);
      setError("");
    } catch (requestError) {
      setError(formatApiError(requestError));
    }
  }, [tab]);
  useEffect(() => { load(); }, [load]);

  const counts = data?.counts || {};
  return (
    <div className="app-shell" data-testid="progress-notes-shell">
      <AppSidebar activeItem="Progress notes" />
      <div className="app-content">
        <AppHeader />
        <main className="dashboard-page" data-testid="progress-notes-page">
          <div className="page-intro">
            <div>
              <p className="eyebrow">PROVIDER PAY</p>
              <h1>Progress notes</h1>
              <p className="page-subtitle">Each approved note pays 30 minutes at the provider's hourly rate. Approve, return with a note, or pull the pay lines for a pay period. Student initials only.</p>
            </div>
          </div>
          <div className="pipeline-tabs" data-testid="progress-notes-tabs">
            {TABS.map(([key, label]) => (
              <button key={key} type="button" className={`pipeline-tab ${tab === key ? "active" : ""}`} data-testid={`progress-notes-tab-${key}`} onClick={() => { setNotice(""); setSearchParams({ tab: key }); }}>
                {label}{key !== "pay_lines" && <em>{counts[key] ?? "…"}</em>}
              </button>
            ))}
          </div>
          {error && <p className="form-message error-message" data-testid="progress-notes-review-error">{error}</p>}
          {notice && <p className="form-message success-message" data-testid="progress-notes-review-notice">{notice}</p>}
          {tab === "pay_lines" ? <ProgressNotePayLines /> : (
            <section className="progress-notes-review" data-testid="progress-notes-review-list" aria-busy={!data}>
              {!data && <p className="projection-loading">Loading progress notes…</p>}
              {data && !data.submissions.length && <p className="operations-empty-state" data-testid="progress-notes-review-empty">{tab === "Submitted" ? "Nothing waiting for approval." : `No ${tab.toLowerCase()} submissions yet.`}</p>}
              {data?.submissions.map((item) => (
                <ProgressNoteReviewCard key={item.id} item={item} onChanged={(message) => { setNotice(message); load(); }} onError={setError} />
              ))}
            </section>
          )}
        </main>
      </div>
    </div>
  );
}
